const RAW_ALIASES = {
  fees: ['fee','fees','fee-management','fee_management','fees-management','fees_management','fees-installments','fee-installments','fees-and-installments'],
  finance: ['finance','financial','financial-accounting','financial_accounting','finance-accounting','finance_accounting','accounting','accounts','financial-accounts'],
  exams: ['exam','exams','examination','examinations','exam-management'],
  students: ['student','students','student-management','student_management'],
  admissions: ['admission','admissions','admissions-crm','admission-crm'],
  academics: ['academic','academics','academic-management'],
  attendance: ['attendance','attendances'],
  learning: ['learning','assignment','assignments','homework','assignments-learning'],
  documents: ['document','documents','certificates','id-cards-certificates','id-card-certificates'],
  gatepass: ['gatepass','gate-pass','gate_pass'],
  transport: ['transport','transportation'],
  clinical: ['clinical','clinical-practical','clinical_practical','practical'],
  live: ['live','live-classes','live_classes','video','video-lectures'],
  website: ['website','web-site','custom-domain','website-custom-domain'],
  communication: ['communication','communications','notifications','notification','whatsapp','notifications-whatsapp'],
  library: ['library','library-management'],
  inventory: ['inventory','stock','inventory-management'],
  payroll: ['payroll','salary','salaries'],
  reports: ['report','reports','reporting'],
  formbuilder: ['formbuilder','form-builder','form_builder','forms'],
  settings: ['setting','settings'],
  uniform: ['uniform','uniforms','uniform-management','uniform_management','uniform-stock','uniform_store'],
  behaviour: ['behaviour','behavior','student-behaviour','student-behavior','discipline','discipline-records'],
  digitalcourses: ['digitalcourses','digital-courses','digital_courses','online-courses','online_courses','course-marketplace','learning-marketplace'],
  discussion: ['discussion','groupdiscussion','group-discussion','group_discussion','student-group-discussion','student_group_discussion','student-discussions'],
  meetings: ['meetings','teachermeetings','teacher-meetings','teacher_meetings','teacher-meetings-google-meet','teacher_meetings_google_meet','google-meet','googlemeet','gmeet'],
};

export function normalizeModuleToken(value='') {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

const ALIAS_MAP = (() => {
  const map = new Map();
  Object.entries(RAW_ALIASES).forEach(([canonical, aliases]) => {
    map.set(normalizeModuleToken(canonical), canonical);
    aliases.forEach(alias => map.set(normalizeModuleToken(alias), canonical));
  });
  return map;
})();

export function canonicalModuleKey(value='') {
  const token = normalizeModuleToken(value);
  return ALIAS_MAP.get(token) || token;
}

export function canonicalModuleKeys(values=[]) {
  return [...new Set((Array.isArray(values) ? values : [values]).map(canonicalModuleKey).filter(Boolean))];
}

export function sameModuleKey(a,b) {
  const aa = canonicalModuleKey(a), bb = canonicalModuleKey(b);
  return !!aa && aa === bb;
}

export const CORE_BUSINESS_MODULES=['students','admissions','fees','finance','exams'];
export function isCoreBusinessModule(value=''){return CORE_BUSINESS_MODULES.includes(canonicalModuleKey(value));}
export function isCoreNavigationModule(value='') {
  const key=canonicalModuleKey(value);
  return ['dashboard','settings','branches'].includes(key)||isCoreBusinessModule(key);
}
